import React from 'react';
import LoadingDots from './loadingdots';

const {Masonry, EaseIn} = polyphony.components.generic;

export const MasonryArchive = ({
    backgroundColor, dotColor,

    bordered, textShadow,

    children
}) => {
    const isHome = polyphony.useState(({is}) => is.front_page);
    const {
        posts, total_count, terms,
        loadingMore, loadingReplacement
    } = polyphony.useState(({posts, total_count, terms, loadingMore, loadingReplacement}) => ({
        posts, total_count, terms,
        loadingMore, loadingReplacement
    }));

    const isBottom = polyphony.hooks.useBottom(() => {
        let offset = 100;
        let footer = document.querySelector('.footer');
        if (footer) {
            offset += footer.getBoundingClientRect().height;
        }
        return offset;
    });
    React.useEffect(() => {
        if (isBottom) {
            const loadMore = () => {
                if (loadingMore || loadingReplacement) {
                    setTimeout(100, loadMore);
                } else {
                    polyphony.loadMoreContent();
                }
            };
            loadMore();
        }
    }, [isBottom]);

    let tiles = [];

    for (let x of [...posts || [], ...terms || []]) {
        let widthUnits = x.meta[(isHome ? 'home_' : '') + 'aspect_x'] || 1;
        let heightUnits = x.meta[(isHome ? 'home_' : '') + 'aspect_y'] || 1;
        tiles.push(<Masonry.Tile key={x.ID || x.id} widthUnits={widthUnits} heightUnits={heightUnits} key={x.ID || x.id}>
            <EaseIn style={{boxSizing: 'border-box', border: bordered ? '1px solid #DDD' : undefined, background: textShadow ? 'radial-gradient(hsla(0, 0%, 20%, 0.36), transparent)' : undefined}}>
                {React.Children.map(children, c => React.cloneElement(c, {post: x, key: x.ID}))}
            </EaseIn>
        </Masonry.Tile>);
    }

    return <div style={{backgroundColor, height: '100%'}}>
        {!loadingReplacement && <Masonry unitsWide={MasonryArchive.unitsWide}>{tiles}</Masonry>}
        {(loadingMore || loadingReplacement) && (!posts || posts.length < total_count) && (!terms || terms.length < total_count) && <div style={{display: 'flex', backgroundColor, justifyContent: 'center'}}><LoadingDots dotStyle={{backgroundColor: dotColor || "white"}}/></div>}
    </div>;
};

MasonryArchive.unitsWide = 4;

MasonryArchive.defaultProps = {
    clickable: false,
    hideTextShadow: false,
    backgroundColor: 'black',
    bordered: false
};

export default MasonryArchive;

